import { Card, CardContent, styled } from '@mui/material';

export const CardStyled = styled(Card)(({ theme }) => ({
  width: '100%',
  color: 'white',
  background: theme.palette.primary.main,
  border: `1px solid ${theme.palette.secondary.dark}`,
  paddingTop: '2rem',
}));

export const CardContentStyled = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '1rem',
  flexDirection: 'column',
  height: 'auto',

  [theme.breakpoints.up('sm')]: {
    alignItems: 'start',
    flexDirection: 'row',
    height: '6rem',
    gap: '1.5rem',
  },
}));

export const AlignTitle = styled('div')(({ theme }) => ({
  padding: '0 1.5rem 1.5rem 1.5rem',
}));
